import { render, staticRenderFns } from "./FourNav.vue?vue&type=template&id=58e2562e"
import script from "./FourNav.vue?vue&type=script&lang=js"
export * from "./FourNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports